import { PublicBookingFields } from '../core/bookings';
import type {
  CanRescheduleResponse,
  CommitRescheduleDto,
  RescheduleContextQuery,
} from '../core/reschedule';
import { RescheduleContextDto } from '../core/reschedule';
import { HttpClient } from './http';

export interface RescheduleService {
  getContext: (
    urlCode: string,
    query?: RescheduleContextQuery,
  ) => Promise<RescheduleContextDto>;
  getCanReschedule: (code: string) => Promise<CanRescheduleResponse>;
  commit: (
    urlCode: string,
    start: string,
    end: string,
    appointmentTypeId?: string,
  ) => Promise<PublicBookingFields | null>;
}

export function createRescheduleService(
  httpClient: HttpClient,
  baseUrl: string,
): RescheduleService {
  return {
    getContext: (urlCode: string, query?: RescheduleContextQuery) => {
      const view = query?.view ? `?view=${encodeURIComponent(query.view)}` : '';
      return httpClient<RescheduleContextDto>(
        `${baseUrl}/reschedule/${encodeURIComponent(urlCode)}${view}`,
        'get',
      );
    },
    getCanReschedule: (code: string) => {
      return httpClient<CanRescheduleResponse>(
        `${baseUrl}/reschedule/can-reschedule/${encodeURIComponent(code)}`,
        'get',
      );
    },
    commit: (
      urlCode: string,
      start: string,
      end: string,
      appointmentTypeId?: string,
    ) => {
      const dto: CommitRescheduleDto = {
        urlCode,
        start_time_utc: start,
        end_time_utc: end,
        ...(appointmentTypeId && { appointment_type_id: appointmentTypeId }),
      };
      return httpClient<PublicBookingFields | null>(
        `${baseUrl}/reschedule/commit`,
        'post',
        {
          body: dto,
        },
      );
    },
  };
}
